module.exports = __webpack_public_path__ + "static/img/fzjx.90c3c74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fzjx.png
// module id = X/Ll
// module chunks = 1